import React from "react";
import './CInfoMessage.css';
import {withTranslation} from 'react-i18next';

const CInfoMessage = (props) => {
    // const { t } = props;
    const msg = props.msg && props.msg.details ? props.msg.details : props.msg;
    const show = props.show || (props.show === undefined);
    return show && msg ? (<div role="alert" className="fade alert show custom-alert-bg"><span>{msg}</span>
    </div>) : null;
}

export default withTranslation('common')(CInfoMessage);